// extracted by mini-css-extract-plugin
export default {"btn":"iconTextButton_btn__GXqIi","icon":"iconTextButton_icon__pD5sz","text":"iconTextButton_text__n8EXR"};